import React, { Fragment, useCallback, useEffect, useMemo, useState } from 'react';
import { wire } from 'react-hot-wire';

import View from 'components/_/common/view/list/ListView';

import useFetch from 'components/_/hooks/useFetch';

import { CafeteriaFilters } from './filters/CafeteriaFilters';
import { Cafeteria } from './Cafeteria';
import { FormattedMessage } from 'react-intl';
import { useHistory, useLocation } from 'react-router-dom';

const CafeteriaView = props => {
	const rewardCafeteriaService = props['services.rewardCafeteriaService'];
	const userProfileService = props['services.userProfileService'];
	const history = useHistory();
	const location = useLocation();
	const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

	const wallet = userProfileService.user().wallet;

	const [search, setSearch] = useState('');
	const [filters, setFilters] = useState({
		from: null,
		to: null,
		afford: false,
		categoryId: queryParams.get('categoryId') || null,
	});
	const setCategoryId = useCallback(
		categoryId => {
			setFilters(state => ({ ...state, categoryId }));
		},
		[setFilters]
	);

	// Fetch first item for get cafeteria currency:
	const { response: currency } = useFetch(() =>
		rewardCafeteriaService.fetchList({ offset: 0, limit: 1 }).then(({ list }) => {
			const currencyName = list[0].price.codeName();

			return wallet.getCurrencyByName(currencyName);
		})
	);
	const { response: categoryList } = useFetch(() => rewardCafeteriaService.fetchCategoryList());

	const showFilters = !!currency || (!!categoryList && !!categoryList.length);

	useEffect(() => {
		if (filters.categoryId) {
			history.replace({
				...location,
				search: `?categoryId=${filters.categoryId}`,
			});
		} else {
			history.replace({
				...location,
				search: '',
			});
		}
	}, [filters]);

	return (
		<View
			name="cafeteria"
			i18nKey="cafeteria"
			search={search}
			setSearch={setSearch}
			tabs={{
				url: '/reward-cafeteria', // eslint-disable-line no-template-curly-in-string
				list: [
					{
						tab: '',
						content: <FormattedMessage id="achievement-list.all-tab" />,
					},
				],
			}}
		>
			<Fragment>
				<hr className="d-none d-sm-block mb-4 mb-sm-5" />
				<div className="cafeteria">
					<div className="d-flex flex-column flex-sm-row fs-4">
						{showFilters && (
							<CafeteriaFilters
								filters={filters}
								onChange={setFilters}
								currency={currency}
								categoryList={categoryList}
								selectedCategoryId={filters.categoryId}
								onCategoryChange={setCategoryId}
							/>
						)}
						<Cafeteria
							filters={filters}
							search={search}
							rewardCafeteriaService={rewardCafeteriaService}
							currency={currency}
						/>
					</div>
				</div>
			</Fragment>
		</View>
	);
};

export default wire(['services.rewardCafeteriaService', 'services.userProfileService'], CafeteriaView);
